import { useState } from "react"
import { auth } from "@/lib/firebase"
import { toast } from "sonner"
import { Document } from "@/types"

export const useDocumentDownload = () => {
	const [isDownloading, setIsDownloading] = useState(false)

	const downloadDocument = async (caseId: string, documentData: Document) => {
		setIsDownloading(true)
		try {
			const user = auth.currentUser
			if (!user) {
				toast.error("You must be logged in to download documents")
				return
			}

			const token = await user.getIdToken()
			const response = await fetch(
				`${import.meta.env.VITE_API_URL}/api/cases/${caseId}/documents/${documentData.id}/view/`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)

			if (!response.ok) {
				throw new Error(`Failed to download: ${response.statusText}`)
			}

			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)
			const a = document.createElement("a")
			a.href = url
			a.download = documentData.name
			document.body.appendChild(a)
			a.click()
			window.URL.revokeObjectURL(url)
			document.body.removeChild(a)
		} catch (error) {
			console.error("Download error:", error)
			toast.error("Failed to download document")
		} finally {
			setIsDownloading(false)
		}
	}

	return { downloadDocument, isDownloading }
}